module.exports = __webpack_public_path__ + "static/media/Server-cuate.0fd8749e.svg";